import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../../css/TopTabs.css";

const TopTabs: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Tab data
  const tabs = [
    { label: "Forms", path: "/forms" },
    { label: "Define Roles", path: "/roles" },
    { label: "Define Stations", path: "/stations" },
    { label: "Onboard Centers", path: "/centers" },
    { label: "Onboard Users", path: "/users" },
    { label: "Slot Design", path: "/slots" },
  ];

  return (
    <div className="core-functions-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          className={location.pathname === tab.path ? "active" : ""}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
        
      ))}
    </div>
  );
};

export default TopTabs;
